import { RowCrudStatus } from "../../common/types";
import { BotPhase } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";

let uniqueCounter = 1;
export type BotPhaseValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  screenshot: string;
  screenshot_data: FileCRUDType;
  __screenshot_files: FileCRUDType[];
};

export type BotPhaseErrorsType = {
  screenshot?: { message: string; fieldLabel: string };
};

export function BotPhaseValuesInit(): BotPhaseValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    screenshot: "",
    screenshot_data: fileCRUDInit(),
    __screenshot_files: [],
  };
}

export type BotPhaseType = BotPhase | BotPhaseValuesType;

export function botPhaseDisplayId(
  source: Partial<BotPhase>,
  _langStore: LangStore
) {
  return (
    (source.phaseNumber?.toString() ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.phaseName ?? _langStore.emptyStringSymbol)
  );
}

export function getBotPhaseValues(
  source: BotPhaseType,
  _langStore: LangStore,
  _duplicated: boolean = false
): BotPhaseValuesType {
  const entityValues = BotPhaseValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : botPhaseDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.__screenshot_files =
    source.screenshot_data && !_duplicated
      ? [
          {
            id:
              "id" in source.screenshot_data && source.screenshot_data.id
                ? source.screenshot_data.id
                : `generated_${uniqueCounter++}`,
            name: source.screenshot_data.name,
            description: source.screenshot_data.description || undefined,
            size: source.screenshot_data.size || 0,
            formattedSize: source.screenshot_data.size
              ? formatBytes(source.screenshot_data.size)
              : "",
            mimetype: source.screenshot_data.mimetype,
            url: source.screenshot_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.screenshot =
    source.screenshot && !_duplicated ? source.screenshot : "";
  entityValues.screenshot_data =
    source.screenshot_data && "__status__" in source.screenshot_data
      ? source.screenshot_data
      : source.screenshot_data
      ? {
          id: ("id" in source.screenshot_data && source.screenshot_data.id
            ? source.screenshot_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.screenshot_data.name,
          description: source.screenshot_data.description || undefined,
          size: source.screenshot_data.size || 0,
          formattedSize: source.screenshot_data.size
            ? formatBytes(source.screenshot_data.size)
            : "",
          mimetype: source.screenshot_data.mimetype,
          url: source.screenshot_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
